import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import { devConfig, profile } from 'config/config'; // Importing devConfig and profile from config
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

export default class FilterWithdrawalRequestView extends JetView {
    // Defining FilterWithdrawalRequestView class
    config() {
        // Configuration method for the view
        const _ = this.app.getService('locale')._; // Localization service for translations
        const right = {
            // Configuration for the right section of the UI
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the input
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date is today
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State',
                            minWidth: 200,
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label for the dropdown
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for the dropdown
                                {
                                    id: '',
                                    value: 'Todos',
                                },
                                {
                                    id: 'A',
                                    value: 'Activo',
                                },
                                {
                                    id: 'I',
                                    value: 'Inactivo',
                                },
                                {
                                    id: 'R',
                                    value: 'Rechazado',
                                },
                                {
                                    id: 'P',
                                    value: 'Pendiente',
                                },
                                {
                                    id: 'E',
                                    value: 'Eliminado',
                                },
                            ],
                        },
                        {
                            margin: 15,
                            css: 'on-row',
                            cols: [
                                {
                                    view: 'checkbox', // Checkbox for filtering by withdrawal date
                                    label: _('Por fecha de retiro pagado'),
                                    labelPosition: 'top',
                                    name: 'ByAllowDate',
                                    value: 0,
                                    minWidth: 200,
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            // Upper section configuration
            id: 'a1',
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [right], // Including the right section
                },
            ],
        };
        const buttons = {
            // Button configuration
            margin: 10,
            minWidth: 200,
            cols: [
                { id: 'grav1', gravity: 4 },
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    width: screen == 'small' ? 0 : 130,
                    minWidth: 200,
                    click: () => {
                        // Clear form values on click
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key triggers this button
                    width: screen == 'small' ? 0 : 130,
                    minWidth: 200,
                    type: 'form',
                    click: () => {
                        // On click, gather filter data and call event
                        const filterdata = this.getRoot().getValues();
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('withdrawalReport:filter', [
                            filterdata, // Pass filter data to event
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            // Second button configuration for the popup
            padding: 10,
            cols: [
                {
                    view: 'button', // Clear button for the second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Consult button for the second form
                    value: _('Consultar'),
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from the second form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('withdrawalReport:filter', [
                            filterdata, // Pass filter data to event
                        ]);
                    },
                },
            ],
        };
        const accordion_section3 = {
            // Scrollable section configuration
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Include upper section
            },
        };
        const accordion_section2 = {
            // Accordion section configuration
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section = {
            // Duplicate accordion section (potential redundancy)
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const filterPopup = webix.ui({
            // Popup window configuration
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title for the popup
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // ID for the second form
                type: 'clean',
                rows: [accordion_section3, buttons2], // Include scrollable section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });
        return {
            // Return the main configuration for the view
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder if screen size is too small
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }
    init(grid) {
        // Initialization method for the view
        webix.ready(function () {
            // Ensure webix is ready before executing
            const lang = this.app.getService('locale').getLang(); // Get current language
            $$('Datepicker').attachEvent('onAfterRender', function () {
                // Attach event after rendering Datepicker
                devConfig.setDateModal(lang); // Set date modal based on language
            });
            if (profile.typeDate !== 2) {
                // Conditional display logic for date fields
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
